import 'qtip2/dist/jquery.qtip.css';
import '../styles/tooltip.less';
import 'qtip2';
import $ from 'jquery';
import * as common from '../../../shared/modules/common';

function getCloseButton(params) {
    return typeof params.closebutton === 'boolean' ? params.closebutton
        : typeof params.closebutton === 'string' ? params.closebutton === 'true'
        : (params.title || '').length === 0 ? false : true;
}

function getMyPosition(placement) {
    return placement === 'top' ? 'bottom'
            : placement === 'bottom' ? 'top'
            : placement === 'right' ? 'left'
            : placement === 'left' ? 'right'
            : 'left';
}

function getAtPosition(placement) {
    return placement === 'top' || placement === 'bottom' || placement === 'left' || placement === 'right'
        ? placement : 'right';
}

function normalizeTriggerEvent(event) {
    var triggerEvent = $.trim(event).toLowerCase();
    // add any potential alias conversions here
    return triggerEvent;
}

function getHoverClickShowEvent() {
    return common.isTouchDevice() ? 'click' : 'mouseenter';
}

function getDefaultShowEvent() {
    return 'mouseenter';
}

function convertToShowEvent(triggerEvent) {
    return triggerEvent === 'focus' ? 'focusin'
        : triggerEvent === 'hover' ? 'mouseenter'
        : triggerEvent === 'click' ? 'click'
        : triggerEvent === 'hoverclick' ? getHoverClickShowEvent()
        : triggerEvent === 'load' ? ''
        : getDefaultShowEvent();
}

function getShowEvent(trigger) {
    var result = getDefaultShowEvent();

    if (trigger) {
        var events = trigger.split(','),
            showEvents = [],
            i,
            len = events.length,
            currentEvent;

        for (i = 0; i < len; i++) {
            currentEvent = normalizeTriggerEvent(events[i]);
            showEvents.push(convertToShowEvent(currentEvent));
        }
        result = showEvents.join(' ');
    }
    return result;
}

function getHoverClickHideEvent() {
    return common.isTouchDevice() ? 'click' : 'mouseleave';
}

function getDefaultHideEvent() {
    return 'mouseleave';
}

function convertToHideEvent(triggerEvent) {
    return triggerEvent === 'focus' ? 'focusout'
        : triggerEvent === 'hover' ? 'mouseleave'
        : triggerEvent === 'click' ? 'click'
        : triggerEvent === 'hoverclick' ? getHoverClickHideEvent()
        : triggerEvent === 'load' ? ''
        : getDefaultHideEvent();
}

function getHideEvent(trigger) {
    var result = getDefaultHideEvent();

    if (trigger) {
        var events = trigger.split(','),
            hideEvents = [],
            i,
            len = events.length,
            currentEvent;

        for (i = 0; i < len; i++) {
            currentEvent = normalizeTriggerEvent(events[i]);
            hideEvents.push(convertToHideEvent(currentEvent));
        }
        result = hideEvents.join(' ');
    }
    return result;
}

function getDisplayOnLoad(trigger) {
    return trigger && trigger.indexOf('load') !== -1;
}

function getDelay(delay) {
    var value = (delay || 0) * 1;
    return value && value > 0 ? value : 0;
}

function getClass(type) {
    var classes = 'uwr-ui-tooltip-base';
    if (type === 'confirm' || type === 'warning' || type === 'error' || type === 'neutral') {
        classes += ' uwr-ui-tooltip-' + type;
    }
    return classes;
}

function buildConfig(params) {
    var config = {
        content: {
            text: params.text || ' ',
            title: {
                text: params.title || '',
                button: getCloseButton(params)
            }
        },
        position: {
            my: getMyPosition(params.placement) + ' center',
            at: getAtPosition(params.placement) + ' center',
            effect: false
        },
        show: {
            event: getShowEvent(params.trigger) || false,
            ready: getDisplayOnLoad(params.trigger),
            delay: getDelay(params.delay),
            effect: false
        },
        hide: {
            event: getHideEvent(params.trigger) || false
        },
        style: {
            classes: 'uwr-ui-tooltip-shadow ' + getClass(params.type),
            tip: {
                corner: true,
                width: 13,
                height: 13
            }
        }
    };
    if ($.trim(config.content.title.text) === '' && config.content.title.button === true) {
        config.content.title.text = ' ';
    }
    return config;
}

function updateTitle($el) {
    var tooltipId = $el.attr('aria-describedby'),
        $titleBar = $('#' + tooltipId + ' .qtip-titlebar'),
        $content = $('#' + tooltipId + ' .qtip-content');
    $titleBar.css({
        'overflow': 'visible',
        'position': 'absolute',
        'padding': '0px',
        'right': '0px'
    });
    $titleBar.find('a').css('z-index', 1);
    $content.css('padding-right', '25px');
    $el.qtip('reposition');
}

function updateForEmptyTitleEvent($el, config) {
    if (!$el.data('updated')) {
        if ($.trim(config.content.title.text) === '' && config.content.title.button) {
            updateTitle($el);
        }
        $el.data('updated', true);
    }
}

function updateForEmptyTitle($el, config) {
    function bindHandler() {
        updateForEmptyTitleEvent($el, config);
    }

    if (config.show.event) {
        var events = $.trim(config.show.event).split(' '),
            i;

        for (i = 0; i < events.length; i++) {
            $el.bind($.trim(events[i]), bindHandler);
        }
    } else {
        updateForEmptyTitleEvent($el, config);
    }
}

function addTooltip($el, params) {
    var config = buildConfig(params);
    $el.qtip(config);
    updateForEmptyTitle($el, config);
    if (params.disabled === 'true') {
        $el.qtip('api').disable(true);
    }
}

function adjustInlineHelpBackground($el) {
    $('input', $el).focusin(function () {
        $el.addClass('uwr-inline-help-active');
    });
    $('input', $el).focusout(function () {
        $el.removeClass('uwr-inline-help-active');
    });
}

function addInlineHelp($el, params) {
    var modParams,
        config;

    // override some params
    modParams = $.extend({placement: 'right'}, params, {trigger: 'focus'});
    config = buildConfig(modParams);

    // add some more params
    config.position.adjust = {
        x: -15
    };
    config.show.target = $('input', $el);

    $el.qtip(config);
    updateForEmptyTitle($el, config);

    // set background
    adjustInlineHelpBackground($el);
}

var dataAttrs = ['closebutton', 'delay', 'disabled', 'placement', 'text', 'title', 'trigger', 'type'];

function buildParams($el) {
    var params = {};
    $.each(dataAttrs, function (i, name) {
        params[name] = $el.attr('data-' + name);
    });
    return params;
}

function addTooltips() {
    $('.uwr-tooltip').each(function () {
        var $el = $(this);
        if ($el.hasClass('uwr-inline-help')) {
            addInlineHelp($el, buildParams($el));
        } else {
            addTooltip($el, buildParams($el));
        }
    });
}

function setVisibility(visible, selector, callback) {
    $(selector).each(function () {
        var elem = $(this);
        if (elem.hasClass('uwr-tooltip')) {
            elem.qtip('api').disable(!visible);
        }
    });
    if ($.type(callback) === 'function') {
        callback();
    }
}

/**
 * Disable displaying the tooltip.
 * @param {string} The CSS selector of the tooltip that will be disabled.
 * @param {function} Optional callback function to do more after tooltip is disabled.
 */
export function disable(selector, callback) {
    setVisibility(false, selector, callback);
}

/**
 * Enable displaying the tooltip.
 * @param {string} The CSS selector of the tooltip that will be enabled.
 * @param {function} Optional callback function to do more after tooltip is enabled.
 */
export function enable(selector, callback) {
    setVisibility(true, selector, callback);
}

/**
 * Initializes all Tooltips on the page. This function like all other API functions is called asynchronously.
 * The no-arg init() is automatically called when the page is loaded.
 * Dynamically added Tooltips need to be initialized by explicitly calling init().
 *
 * @param callback Javascript function object that is called when init() is finished. Optional parameter.
 */
export function init(callback) {
    addTooltips();
    common.invoke(callback);
}



//////////////////
// WEBPACK FOOTER
// ./widgets/Tooltip/js/tooltip.js
// module id = 13
// module chunks = main